module.exports = __webpack_public_path__ + "static/media/19.7d397b3b.jpg";